<template>
    <el-dialog :title="$t('addPermission')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               custom-class="medium-dialog">
        <div class="content">
            <el-form :model="formData"
                     size="mini"
                     :rules="rules"
                     ref="ruleForm"
                     label-width="110px">
                <el-form-item :label="$t('permissionName')"
                              prop="name">
                    <el-input v-model="formData.name"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('code')"
                              prop="code">
                    <el-input v-model="formData.code"
                              autocomplete="off" @input.native="codeDebounce"></el-input>
                </el-form-item>
                <el-form-item :label="$t('sortValue')"
                              prop="sort">
                    <el-input type="number" v-model="formData.sort"
                              autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
    
</template>

<script>
import {updatePermission, permissionCheckCode, queryPermissionDetails} from "@/api/modules/user";
import {Debounce} from "@/utils/common";

export default {
    name: "Edit",
    // 组件
    components: {},
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        nodeId: {
            type: String,
            default: ''
        },
    },
    data() {
        let checkCode = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t('pleaseInputHint')));
            }
            if (this.codeUsable) {
                callback()
            } else {
                callback(new Error(this.$t('codeRepeat')));
            }
        };
        return {
            dialogVisible: false,
            formData: {
                parentId: '',
                name: '',
                code: '',
                sort: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                code: [{ required: true, validator: checkCode, trigger: 'blur' }],
                sort: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
            },
            codeUsable: true,   // 编码是否可用
            disabled: false
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    // 方法集合
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.codeUsable = true
            this.getDetails()
        },
    
        // 获取详情
        getDetails () {
            queryPermissionDetails(this.nodeId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    this.formData = {
                        parentId: resData.parentId,
                        name: resData.name,
                        code: resData.code,
                        sort: resData.sort
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        
        // 校验编码是否重复
        codeDebounce: Debounce(function () {
            if (!this.formData.code) {
                this.$refs.ruleForm.validateField('code')
                return;
            }
            const params = {
                id: this.nodeId,
                code: this.formData.code.trim()
            }
            permissionCheckCode(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.codeUsable = !res.data.duplicate
                    this.$refs.ruleForm.validateField('code')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            })
        }, 500),
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            const params = {
                id: this.nodeId,
                parentId: this.formData.parentId,
                name: this.formData.name.trim(),
                code: this.formData.code.trim(),
                sort: this.formData.sort
            }
            this.disabled = true;
            updatePermission(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'success'
                    })
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
    
    },
    // 组件被激活
    activated() {
    
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
.content{
    width: 620px;
    .content-title{
        height: 80px;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
    }
    .content-handle{
        width: 100%;
        margin-top: 50px;
        display: flex;
        justify-content: center;
    }
}
</style>
